import React, { useEffect, useState } from "react";
import { Button, NavBar, Grid, Toast, Popup, Mask } from "antd-mobile";
import { APPLICATION_SCREEN, ISwitchScreenAction } from "../../App";
import RequestHelper from "../../common/RequestHelper";
import LoadingView from "../../components/LoadingView";
import { eventsVietNam, MAIN_COLOR } from "../../common/Constants";
import moment from 'moment';
import 'moment-lunar';
import { getAnalytics, logEvent } from "firebase/analytics";

const today = new Date();
today.setHours(0, 0, 0, 0)
const currentYear = today.getFullYear();
const days = ["Chủ Nhật", "Thứ Hai", "Thứ Ba", "Thứ Tư", "Thứ Năm", "Thứ Sáu", "Thứ Bảy"];
const analytics = getAnalytics();
    

export default function Holiday({ setScreen } : ISwitchScreenAction) {

  interface IListItem {
    id?: string,
    name: string,
    date: string, // DD/MM
    date_lunar?: string,
    date_full?: number,
    desc?: string,
    minor?: boolean,
  }

  const [list, setList] =useState<IListItem[]>([])
  const [loading, setLoading] = useState(true);
  const [time, setTime] = useState<string>("");
  const [showDetails, setShowDetails] = useState(false);
  const [details, setDetails] = useState('');
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setWindowHeight(window.innerHeight);
    };

    // Lắng nghe sự kiện thay đổi kích thước
    window.addEventListener('resize', handleResize);

    // Dọn dẹp sự kiện khi component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    const updateClock = () => {
      const now = new Date();

      const day = String(now.getDate()).padStart(2, "0");
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const year = now.getFullYear();

      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      const seconds = String(now.getSeconds()).padStart(2, "0");

      const today = new Date();
      const dayOfWeek = today.getDay(); // Trả về số từ 0 đến 6 (0 là Chủ Nhật, 6 là Thứ Bảy)

      const dayStrIndex = ""

      setTime(` ${days[dayOfWeek]} ${dayStrIndex} ${day}/${month}/${year} ${hours}:${minutes}:${seconds}`);
    };

    // Cập nhật đồng hồ mỗi giây
    const timer = setInterval(updateClock, 1000);

    // Hiển thị ngay lập tức khi trang vừa tải
    updateClock();

    // Dọn dẹp bộ hẹn giờ khi component unmount
    return () => clearInterval(timer);
  }, []);

  const getList = async () => {
    try {
      // Fetch from firebase
      const holidays: IListItem[] = []
      for (let index = 0; index < eventsVietNam.events.length; index++) {
        const element = eventsVietNam.events[index]
        // const dateFull = Number(moment(element.date, 'DD/MM').format('YYYYMMDD'))
        const dateArr = element.date.split('/')
        let dateSolar = moment().month(Number(dateArr[1])-1).date(Number(dateArr[0]));
        // if date has past, then make it future by adding year + 1
        if (dateSolar.isBefore(moment())) {
          dateSolar = moment().month(Number(dateArr[1])-1).date(Number(dateArr[0])).year(dateSolar.year() + 1)
        }
        const dateFull = Number(dateSolar.format('YYYYMMDD'))
        holidays.push({
          name: element.name,
          date: element.date,
          date_full: dateFull,
          desc: element.desc,
        })
      }
      for (let index = 0; index < eventsVietNam.events_lunar.length; index++) {
        const element = eventsVietNam.events_lunar[index]
        // if (element.minor) {
        //   continue;
        // }
        const dateArr = element.date.split('/')
        // Need to check if solar
        let dateSolar = moment().month(Number(dateArr[1])-1).date(Number(dateArr[0])).solar();
        if (dateSolar.isBefore(moment())) {
          dateSolar = moment().month(Number(dateArr[1])-1).date(Number(dateArr[0])).year(dateSolar.year() + 1).solar()
        }
        const date = dateSolar.format('DD/MM')
        const dateFull = dateSolar.format('YYYYMMDD')
        holidays.push({
          name: element.name,
          date: date,
          date_lunar: element.date,
          date_full: Number(dateFull),
          desc: element.desc,
          minor: element.minor
        })
      }
      // Sort holidays by date asc
      holidays.sort((a, b) => {
        // const [dayA, monthA] = a.date.split('/').map(Number);
        // const [dayB, monthB] = b.date.split('/').map(Number);
    
        // // So sánh tháng trước
        // if (monthA !== monthB) {
        //     return monthA - monthB;
        // }
    
        // Nếu cùng tháng, so sánh ngày
        // return dayA - dayB;
        if (a.date_full && b.date_full)
        return a.date_full - b.date_full
        return 0
    });
    
    setList(holidays)

    } catch (error) {
      console.log(error)
      Toast.show('Lấy thông tin game lỗi, hãy thử lại')
    }
    
    setLoading(false)
  }

  useEffect(()=> {
    getList()
  },[])

  const renderList = () => {
    const listItems = []
    for (let i = 0; i < list.length; i++) {
          if (list[i].minor) {
            continue;
          }
          listItems.push(<div key={`index-${i}`} onClick={ ()=> {
            setDetails(list[i].desc??'')
            logEvent(analytics, 'gift_holiday_'+list[i].date);
            setShowDetails(true)
            setTimeout(()=> {
              var myDiv = document.getElementById('detail-event');
            // myDiv?.innerHTML = variableLongText;
            // myDiv?.scrollTo({top: 0})
            // myDiv?.animate({ scrollTop: 0 }, 100);
            console.log(myDiv)
            myDiv?.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"})
            // alert('scrolled')
            }, 1000)
            // setScreen(APPLICATION_SCREEN.GAME_HISTORY_DETAIL, {historyId: listHistories[i].id})
          }} style={{
            display: 'flex', 
            flexDirection: 'row', 
            alignItems: 'center', 
            justifyContent: 'center', 
            marginTop: 16,
            borderBottomColor: 'lightgrey',
            borderBottomStyle: 'dotted',
            marginLeft: 16, 
            marginRight: 16}}>
            <span style={{fontSize: 14, fontWeight: '600', color: MAIN_COLOR}}>{list[i].name}</span>
            <span style={{flex: 1}}></span>
            <span style={{fontSize: 14, fontWeight: '600', color: '#10141B'}}>{moment(list[i].date_full, 'YYYYMMDD').format('DD/MM/yyyy')} {list[i].date_lunar ? `(${list[i].date_lunar } âm lịch)`: ''}</span>
          </div>)
        }
      return listItems
  }

  if (loading) {
    return <LoadingView />
  }

  const renderNextEvent = () => {
    // const reversedList = Object.assign([], list);
    // reversedList.reverse();
    // const holidayDates = list.map(event => {
    //   const [day, month] = event.date.split("/").map(Number);
    //   const date = new Date(currentYear, month - 1, day)
    //   date.setHours(0, 0, 0, 0)
    //   return date;
    // });
  
    // Lọc các ngày lễ từ hiện tại trở đi và tìm ngày gần nhất
    const closestHoliday = list
      .filter(date => date.date_full??0 >= Number(moment().format('YYYYMMDD')))[0];
  
    if (closestHoliday) {
      console.log(`Ngày lễ gần nhất là: ${closestHoliday.date_full}`);
      console.log(closestHoliday)
      const event = list.find(event => event.date === closestHoliday.date)
      const inNumbersOfDay = moment(closestHoliday.date_full, 'YYYYMMDD').startOf('day').diff(moment().startOf('day'), 'days')
      let msg = ''
      let eventName = ''
      if (inNumbersOfDay === 0) {
        msg = 'Sự kiện ngày hôm nay :'
        // calculate if more than one event today
        let eventsInday: string[] = []
        list.filter(event => event.date === closestHoliday.date).forEach(event => {
          eventsInday.push(event?.name)
        })
        eventName += eventsInday.join(', ')
      } else {
        msg = 'Sự kiện diễn ra trong ' + (Math.abs(inNumbersOfDay)) + ' ngày nữa :'
      }
    return <div onClick={()=> {
      if (event?.minor) {
        return;
      }
      setDetails(event?.desc??'')
      logEvent(analytics, 'gift_holiday_'+event?.date);
      setShowDetails(true)
    }} style={{fontSize: 14, marginLeft: 16, marginRight: 16, marginTop: 8, color: 'rgb(18, 78, 89)'}}><span style={{color: inNumbersOfDay === 0 ? 'rgb(27, 170, 122)' : 'rgba(14, 204, 144, 1)'}}>{msg} <span>{moment(closestHoliday.date_full, 'YYYYMMDD').format('DD/MM/yyyy')} - {eventName}</span></span></div>
    } else {
      console.log("Không còn ngày lễ nào trong năm nay.");
      return null;
    }
  }

  // useEffect(()=> {
  //   if (showDetails) { document.body.style.position = 'fixed'; } else { }
  // }, [showDetails])

  const renderEventDetails = () => {
    return <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, display: 'flex',  height: '70vh', marginTop: '30vh', flexDirection: 'column', backgroundColor: 'white'}}>
      <div id="detail-event" className="modalscroll" style={{whiteSpace: 'pre-line', flex: 1,fontSize: 15, fontWeight: 'bold', color: 'rgb(18, 78, 89)', paddingLeft: 16, paddingRight: 16, paddingBottom: 56, paddingTop: 16}}>
      {details}
      </div>
      <div style={{marginTop: 8, marginBottom: 8, textAlign: 'center'}}>
        <Button onClick={()=> {
          setShowDetails(false);
        }}>Đóng lại</Button>
      </div>
    </div>
  }

  return (
    <div>
      <NavBar style={{}} onBack={()=> {
              // setScreen(APPLICATION_SCREEN.JOIN_GAME_INPUT)
      }} >Các sự kiện, ngày lễ trong năm</NavBar>
      <div style={{ fontSize: "1rem", fontFamily: "Arial, sans-serif", textAlign: 'right', marginRight: 16, color: 'rgb(27, 170, 122)'}}>
      Hôm nay là {time}
      </div>
      <div  style={{marginTop: 8}}>
      <div style={{
        display: 'flex', 
        flexDirection: 'column', 
        marginLeft: 16, marginRight: 16,
        borderColor: 'rgba(16, 20, 27, 0.08)', 
        borderStyle: 'solid', 
        borderWidth: 1, 
        paddingBottom: 16,
        borderRadius: 16}}>
          {/* <label style={{
            color: '#10141B', 
            fontSize: 16, 
            fontWeight: '700', 
            textAlign: 'center', 
            marginTop: 16, 
            marginBottom: 20}}>Lịch sử</label> */}
          <div style={{
            display: 'flex', 
            flexDirection: 'row', 
            alignItems: 'center', 
            justifyContent: 'center', 
            marginTop: 16,
            marginLeft: 16, 
            marginRight: 16}}>
            <span style={{fontSize: 13, fontWeight: '500', color: '#6E7074'}}>Sự kiện</span>
            <span style={{flex: 1}}></span>
            <span style={{fontSize: 13, fontWeight: '500', color: '#6E7074'}}>Ngày</span>
          </div>
          {renderNextEvent()}
        {renderList()}
        <Mask visible={showDetails} onMaskClick={()=> {setShowDetails(false)}}>
          {renderEventDetails()}
        </Mask>
        {/* <Popup
          visible={showDetails}
          onMaskClick={() => {
            setShowDetails(false)
          }}
          onClose={() => {
            setShowDetails(false)
          }}
          
          bodyStyle={{ height: '80vh', position: 'fixed' }}
        >
          {renderEventDetails()}
        </Popup> */}
      </div>
      </div>
    </div>
  );
}
